<template>
  <main>
    <section class="fk-contents">
      <h2 class="title-lv2 mb20">{{$t('Order.ProcessingHeading')}}</h2>

      <div class="mod-notes-box">
        <dl>
          <dt>{{$t('Order.Readme')}}</dt>
          <dd>{{$t('Order.ReadmeBody')}}</dd>
        </dl>
      </div>

      <div class="mod-has-label">
        <span class="label">{{$t('Order.OrderNumber')}}</span>
        <div class="order-num-box">
          <h3 class="order-num">{{getOrderDetail.ticketNumber}}</h3>
        </div>
      </div>

      <div class="mod-has-label">
        <span class="label">{{$t('Order.ReceiveInfo')}}</span>
        <div class="mod-normal-box confirm">
          <h3 class="title-lv3">{{getOrderDetail.receiveMethod}}</h3>
        </div>
      </div>

      <div class="mod-has-label">
        <span class="label">{{$t('Cart.OrderDetail')}}</span>
        <div class="mod-normal-box">
          <div class="order-detail-wrap">
            <!-- *** 商品 *** -->
            <div class="order-detail-item" v-for="(item, index) in getOrderDetail.items" :key="index">
              <h3 class="item-coupon-use" v-if="item.isUseCoupon">{{text.UseCoupon}}</h3>
              <h3 class="item-name"><span v-html="item.name"></span></h3>
              <div class="quantity">{{text.Quantity}}{{item.quantity}}</div>
              <p class="order-price"><strong>¥{{displayThousandsSeparator(item.price)}}</strong><small>{{item.taxType}}</small></p>
            </div>
            <!-- *** 商品 *** -->
            <!-- *** 会計割引クーポン *** -->
            <div class="order-detail-item" v-if="getOrderDetail.accountingCoupon.isUse">
              <h3 class="item-coupon-use">{{text.UseCoupon}}</h3>
              <h3 class="item-name"><span v-html="getOrderDetail.accountingCoupon.title"></span></h3>
              <p class="order-price"><strong>¥{{displayThousandsSeparator(getOrderDetail.accountingCoupon.discountPrice)}}</strong><small>{{getOrderDetail.accountingCoupon.taxType}}</small></p>
            </div>
            <!-- *** 会計割引クーポン *** -->

            <p class="total-price"><small>{{$t('General.Total')}}</small><strong>¥{{displayThousandsSeparator(getOrderDetail.totalPrice)}}</strong><small>{{getOrderDetail.taxType}}</small></p>
          </div>
        </div>
      </div>

      <p class="mod-form-btn"><a href="#" class="btn-base btn-main" @click.prevent="reload">{{$t('General.Reload')}}</a></p>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
import {get} from 'lodash'
export default {
  name: 'FKMOOrderProcessing',
  mixins: [ CommonMixin, DisplayErrorMixin ],
  data () {
    return {
      pollingTimer: null,
      isPosting: false, // APIの二重リクエスト防止フラグ
      cancelSource: null,
      text: {
        CouponExcluded: null,
        NotApplying: null,
        UseCoupon: null,
        Quantity: null
      }
    }
  },
  computed: {
    getOrderDetail () {
      return this.$store.getters.orderDetail
    }
  },
  methods: {
    setPostingFlag: function () {
      this.isPosting = true
    },
    removePostingFlag: function () {
      this.isPosting = false
    },
    // ポーリングを開始する
    init: function () {
      // PayPay支払い時はバックエンドからストレージの復旧をする
      if (get(this, '$route.query.bskey', undefined) !== undefined) {
        let _that = this
        this.callApi('GetStorage',
          {
            'bskey': this.$route.query.bskey
          }
        ).then((res) => {
          const storageArray = JSON.parse(decodeURI(atob(JSON.parse(res.data.value.storageJson).encodedData)))
          sessionStorage.setItem('lang', storageArray.lang)
          sessionStorage.setItem('vuex', storageArray.vuex)
          if (get(storageArray, 'login', null) !== null) {
            sessionStorage.setItem('login', storageArray.login)
            _that.$store.dispatch('setUserAuthority', get(JSON.parse(storageArray.login), 'authority', 1))
          }
          if (get(storageArray, 'email', null) !== null) {
            sessionStorage.setItem('email', storageArray.email)
          }

          const order = get(JSON.parse(storageArray.vuex), 'order_detail')
          // Storeデータ復元(PayPay等でブラウザからアプリに遷移した場合、Storeの情報が消えてしまっている)
          _that.$store.dispatch('setSelectStore', get(JSON.parse(storageArray.vuex), 'select_store'))
          _that.$store.dispatch('setDisabledButton', get(JSON.parse(storageArray.vuex), 'disabledButton'))
          // 注文番号取得
          _that.callApi('GetTicketNumber',
            order
          ).then((res) => {
            order.ticketNumber = res.data.value.ticketNumber
            _that.$store.dispatch('setOrderDetail', order)

            // カート情報をクリアする
            _that.clearCart(true)
          })
        })
      }
      // SBPSリンク型決済(PayPay以外)からの遷移の場合、注文番号を取得する
      if (localStorage.getItem('linkPayMethod') && localStorage.getItem('linkPayMethod') !== 'paypay') {
        // sessionStorageを復元する
        sessionStorage.setItem('lang', localStorage.getItem('lang_link'))
        sessionStorage.setItem('vuex', JSON.parse(localStorage.getItem('vuex_link')))
        if (localStorage.getItem('login_link') !== null) {
          sessionStorage.setItem('login', localStorage.getItem('login_link'))
          this.$store.dispatch('setUserAuthority', get(JSON.parse(localStorage.getItem('login_link')), 'authority', 1))
        }
        if (localStorage.getItem('email_link') !== null) {
          sessionStorage.setItem('email', localStorage.getItem('email_link'))
        }
        // 退避データを削除
        localStorage.removeItem('lang_link')
        localStorage.removeItem('vuex_link')
        localStorage.removeItem('login_link')
        localStorage.removeItem('email_link')
        localStorage.removeItem('linkPayMethod')
        let that = this
        const order = get(JSON.parse(sessionStorage.getItem('vuex')), 'order_detail')
        // Storeデータ復元(PayPay等でブラウザからアプリに遷移した場合、Storeの情報が消えてしまっている)
        this.$store.dispatch('setSelectStore', get(JSON.parse(sessionStorage.getItem('vuex')), 'select_store'))
        this.$store.dispatch('setDisabledButton', get(JSON.parse(sessionStorage.getItem('vuex')), 'disabledButton'))
        // 注文番号取得
        this.callApi('GetTicketNumber',
          order
        ).then((res) => {
          order.ticketNumber = res.data.value.ticketNumber
          that.$store.dispatch('setOrderDetail', order)

          // カート情報をクリアする
          that.clearCart(true)
        })
      }

      // ポーリング停止が指示されていなければポーリングを開始する
      if (this.$route.params.stopPollingTimer === null || this.$route.params.stopPollingTimer === undefined || !this.$route.params.stopPollingTimer) {
        this.pollingTimer = window.setInterval(() => {
          if (!this.isPosting) {
            this.getOrderProcessing()
          }
        }, this.getPorllingInterval())
      }
    },
    // 更新ボタンをタップする
    reload: function (event) {
      if (this.isPosting) {
        return false
      }
      this.getOrderProcessing()
    },
    getOrderProcessing: function () {
      // Post中フラグを立てる
      this.setPostingFlag()

      const that = this
      // キャンセルトークンを取得する
      this.cancelToken = this.axios.CancelToken
      this.cancelSource = this.cancelToken.source()

      const params = {
        'order_id': this.getOrderDetail.orderId
      }
      // キャンセルトークンをconfigに組み込む
      const config = Object.assign(this.getAjaxRequestHeaders(), { cancelToken: this.cancelSource.token })
      this.axios.post(
        this.getApiUrl('OrderProcessing'),
        params,
        config
      )
      // this.axios.get('/static/stub/OrderProcessing/success_status_99.json', {
      //   cancelToken: this.cancelSource.token
      // })
        .then((res) => {
          if (res.data.result) {
            switch (res.data.value.pos_status) {
              case 5: // 決済完了
              case 6: // 調理完了
                that.stopPollingTimer() // ポーリングを停止する
                // オーダー完了画面に遷移
                that.$router.push({ name: 'OrderComplete' })
                break
              case 99:
                // エラー
                that.stopPollingTimer() // ポーリングを停止する
                that.errorFromApi(99, that.$i18n.t('ErrorMsg.ERR_999'))
                break
              default:
                // 決済が未完了なので遷移しない
                break
            }
          } else {
            that.stopPollingTimer() // ポーリングを停止する
            switch (res.data.errorCode) {
              case 'ERR_MO_078':
                this.$router.push({ name: 'OrderFailed' })
                break
              default:
                // ERR_MO_077, ERR_MO_090他
                that.errorFromApi(res.data.errorCode, res.data.error)
                break
            }
          }
        })
        .catch((error) => {
          that.stopPollingTimer() // ポーリングを停止する
          if (this.axios.isCancel(error)) {
            // ユーザー操作でリクエストがキャンセルされた場合
          } else {
            that.errorFromAxios(error)
          }
        })
        .finally(() => {
          // ポスト中フラグを倒す
          that.removePostingFlag()
        })
    },
    // ポーリングタイマーを停止する
    stopPollingTimer: function () {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    },
    initView: function () {
      this.text.CouponExcluded = this.$i18n.t('Cart.CouponExcluded')
      this.text.NotApplying = this.$i18n.t('Cart.NotApplying')
      this.text.UseCoupon = this.$i18n.t('Cart.UseCoupon')
      this.text.Quantity = this.$i18n.t('General.Quantity')
    }
  },
  beforeMount () {
    this.init()
  },
  mounted () {
    this.initView()
  },
  beforeDestroy () {
    // APIリクエスト中であればキャンセルする
    if (this.isPosting) {
      this.cancelSource.cancel('Api request canceled by the user.')
    }
    // Post中フラグを倒す
    this.removePostingFlag()
    // ポーリングタイマーを停止する
    this.stopPollingTimer()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OrderProcessing.vue